/**
 * Shared helpers for the Manual Trading Hub.
 *
 * Split out of the monolithic Meta5ManualTrading.jsx so each sub-pane can
 * import only what it needs without dragging the whole 3000-line page into
 * its module graph.
 */

export const COMMON_SYMBOLS = ['XAUUSD', 'EURUSD', 'GBPUSD', 'USDJPY', 'BTCUSD', 'US30', 'NAS100'];

// Approximate USD P&L per lot per $1 price move — used ONLY to build the
// Trade-Impact Preview so a trader can sanity-check what happens when the
// order fires on all connected accounts.  Real broker specs may differ; the
// preview is clearly labelled as an estimate.
export const CONTRACT_USD_PER_DOLLAR_MOVE = {
  XAUUSD: 100,   // 100 oz per lot × $1 = $100 per lot per $1
  XAGUSD: 5000,  // 5000 oz per lot
  BTCUSD: 1,     // 1 BTC per lot
  ETHUSD: 1,
  US30: 1,       // 1 index point ≈ $1
  US100: 1,
  NAS100: 1,
  SPX500: 1,
  UK100: 1,
  GER40: 1,
  // FX majors omitted on purpose — a "$1 move" on 100 000 base units is
  // enormous ($100 000/lot) so the preview would be misleading.
};

export function fmtMoney(v, cur = 'USD') {
  if (v == null) return '—';
  return `${Number(v).toFixed(2)} ${cur}`;
}
